import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"

import { 
	GetLocal,
	FetchService
} from "../../../Base/BaseControl";

export default function Index(props) {
	
	const [getServiceResult, setServiceResult] = useState(false);

    useEffect(() => {

    }, []);

	const ShowNoticeCommission =()=>{
        var inputValue = {
            session: GetLocal('OwnersSession')
        };
        FetchService("Owner/Urbanization/Request/ShowNoticeCommission", inputValue, ShowNoticeCommissionSuccess);		
	}

	const ShowNoticeCommissionSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult);
	}			

    return (
        <div class="text-center">	
			{getServiceResult == false && 
				<ButtonControl 
					variant="btn btn-primary w-25"
					title="چاپ ابلاغیه"
					icon="fa fa-print"
					onClick={ShowNoticeCommission}
				/>
			}
			
			{getServiceResult != false && <iframe src={"data:application/pdf;base64,"+getServiceResult} width="100%" height="600"></iframe> }
        </div>
    );
}
